import { useEffect } from 'react';
import $ from 'jquery';
import { FiDownload, FiMail } from 'react-icons/fi';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';

const stats = [
  { num: '2+',   label: 'Years of\nCoding'       },
  { num: '5+',   label: 'Projects\ncompleted'         },
  { num: '5+',   label: 'Technologies\nmastered'      },
  { num: '100+', label: 'Code\ncommits'               },
];

export default function Hero() {
  useEffect(() => {
    const texts = ['CS Student', 'Software Developer', 'Social Entrepreneur', 'Problem Solver'];
    let idx = 0, charIdx = 0, deleting = false;
    let timer;
    const $typed = $('#typed-text');
    const type = () => {
      const cur = texts[idx];
      deleting ? $typed.text(cur.slice(0, --charIdx)) : $typed.text(cur.slice(0, ++charIdx));
      if (!deleting && charIdx === cur.length) { deleting = true; timer = setTimeout(type, 1800); return; }
      if (deleting && charIdx === 0) { deleting = false; idx = (idx + 1) % texts.length; }
      timer = setTimeout(type, deleting ? 55 : 115);
    };
    type();

    // Animate stats count-up on load
    const statsTimer = setTimeout(() => {
      $('.stat-num[data-target]').each(function () {
        const target = parseInt($(this).data('target'));
        const suffix = $(this).data('suffix') || '';
        $(this).prop('counter', 0).animate({ counter: target }, {
          duration: 1600,
          step(now) { $(this).text(Math.ceil(now) + suffix); },
        });
      });
    }, 600);

    return () => { clearTimeout(timer); clearTimeout(statsTimer); };
  }, []);

  return (
    <section id="home" className="hero-section">
      <div className="hero-inner">

        {/* ── LEFT: text ── */}
        <div className="hero-content">
          <span className="hero-label">Hello, I'm</span>
          <h1 className="hero-heading">
            <span className="hero-name-green">Zidane Nait Cheikh</span>
          </h1>

          {/* Typed animation */}
          <p className="hero-typed-line">
            <span id="typed-text"></span>
            <span className="hero-cursor">|</span>
          </p>

          <p className="hero-sub">
            I excel at building clean, functional web applications and
            I am proficient in various programming languages and technologies.
          </p>

          {/* Coordonnées */}
          <div className="hero-coords">
            <a href="mailto:zidanenaitcheikh@gmail.com" className="hero-coord-link">
              <FiMail /> zidanenaitcheikh@gmail.com
            </a>
          </div>

          <div className="hero-actions">
            <a href="/CV_C.pdf" download className="btn-cv">
              DOWNLOAD CV <FiDownload />
            </a>
            <div className="hero-socials">
              <a href="https://github.com/Zidane-Nait-cheikh" target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub /></a>
              <a href="https://www.linkedin.com/in/zidane-nait-cheikh/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        {/* ── RIGHT: circular photo ── */}
        <div className="hero-photo-wrap">
          {/* Outer dashed spinning ring */}
          <div className="ring-dashed" />
          {/* Inner solid glow ring */}
          <div className="ring-glow" />
          {/* Photo circle */}
          <div className="hero-circle">
            <img src="/pic1.jpeg" alt="Zidane Nait Cheikh" />
          </div>
        </div>
      </div>

      {/* ── STATS BAR ── */}
      <div className="hero-stats">
        {stats.map((s, i) => (
          <div key={i} className="stat-item">
            <span className="stat-num" data-target={parseInt(s.num)} data-suffix={s.num.replace(/\d+/, '')}>
              {s.num}
            </span>
            <span className="stat-label">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
